import { Theme } from '@mui/material/styles';
import { secondaryContainerStyling } from '../../styles/sxStyling';

export const parentNoteStyles = {
  border: (theme: Theme) => `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: (theme: Theme) => theme.palette.background.paper,
  padding: 1.5,
  borderRadius: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  fontSize: '0.875rem',
};

export const childNoteStyles = {
  ...secondaryContainerStyling,
  marginBottom: 1,
  border: (theme: Theme) => `1px solid ${theme.palette.divider}`,
  backgroundColor: (theme: Theme) => theme.palette.background.default,
  padding: 1,
};

export const noteSummaryStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  width: '100%',
  gap: 1,
};

export const noteSummaryUserStyles = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const noteSummaryUserInfoStyles = (theme: Theme) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});
export const noteSummaryHeaderStyles = {
  fontSize: '1em',
  fontWeight: 600,
  lineHeight: 1.3,
};
export const noteSummarySecondaryTextStyles = { fontSize: '0.8em', color: 'text.secondary' };
export const noteSummaryEditedTextStyles = { fontSize: '0.8em', fontWeight: 'bold' };
export const noteSummaryTextStyles = {
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  fontSize: '0.9em',
  lineHeight: 1.45,
};

export const noteSummaryActionsStyles = {
  display: 'flex',
  whiteSpace: 'nowrap',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexShrink: 0,
  marginRight: 1,
};

export const noteTableWrapper = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  mt: 1,
  p: 1,
};

export const pushPinIconStyles = (isPinned: boolean) => ({
  transform: isPinned ? 'rotate(45deg)' : 'rotate(0deg)',
  transition: 'transform 0.1s ease-in-out',
  cursor: 'pointer',
});

export const noteReplyToggleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minHeight: '24px',
  cursor: 'pointer',
};

export const noteReplyAvatarGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const noteReplyCountStyles = {
  textDecoration: 'underline',
  fontWeight: 'bold',
};

export const noteReplyHideStyles = {
  cursor: 'pointer',
  minHeight: '24px',
  textDecoration: 'underline',
  fontWeight: 'bold',
  mt: 1,
};
